import { Product, User } from 'declarations'
import _ from 'lodash'
import moment from 'moment'
import React from 'react'
import { useParams } from 'react-router-dom'
import { BookmarkOfProduct } from 'src/common/razzle-platform-bookmarkofproduct/BookmarkOfProduct'
import { useScroll, useWpPlugins } from 'src/common/razzle-platform-components/hooks'
import PageLoader from 'src/common/razzle-platform-components/PageLoader/PageLoader'
import { Link } from 'src/common/razzle-platform-components/router'
import { SEOEnhancer } from 'src/common/razzle-platform-components/seo/SEOEnhancer'
import { SSFC } from 'src/common/razzle-platform-components/types'
import { useProducts } from 'src/common/razzle-platform-product/hooks'
import { getInitialPropsOfProducts } from 'src/common/razzle-platform-product/ssr'
import { useIntl } from 'src/common/razzle-platform-translate'
import GoogleTranslate from 'src/common/razzle-platform-translate/Translate/GoogleTranslate'
import { useUser } from 'src/common/razzle-platform-user/hooks'
import { getInitialPropsOfUser } from 'src/common/razzle-platform-user/ssr'
import { BASE_URL, NUMBER_OF_BEDS_UUID, STATIC_PATH } from 'src/configs'
import { RatingSarts } from 'src/modules/components/RatingSarts'
import { useMessaging } from 'src/modules/utils'
import { productRoutes } from 'src/routes'
import urlJoin from 'url-join'

export const UserDetails: SSFC<{}> = () => {
    const { user, isFirstRequestInPregress } = useUser<User>()
    const { handleSendMessageClick } = useMessaging(user?.id)
    const params = useParams()
    const id = _.get(params, 'id')
    const { products, isFirstRequestInPregress: isFirstRequestInPregressOfProduct } = useProducts<Product>({
        params: { _embed: ['user'], 'user.id': id },
        useUrlParams: false,
        usePagination: false,
    })

    useWpPlugins()
    useScroll()
    const { formatMessage } = useIntl()

    if (isFirstRequestInPregress || !user || isFirstRequestInPregressOfProduct) {
        return <PageLoader />
    }

    const logoUrl = user.avatar?.default
        ? urlJoin(BASE_URL, user.avatar.default)
        : urlJoin(STATIC_PATH, 'assets/images/user_avatar.png')

    return (
        <>
            <SEOEnhancer
                title={formatMessage(
                    { id: '{name}  - Swaptheroad!!!!', defaultMessage: '{name}  - Swaptheroad!!!!' },
                    { name: user.pseudo },
                )}
                description={formatMessage(
                    {
                        id: 'Échangez un véhicule avec {name} et découvrez plein d’autres véhicules.',
                        defaultMessage: 'Échangez un véhicule avec {name} et découvrez plein d’autres véhicules.',
                    },
                    {
                        name: user.pseudo,
                    },
                )}
                imageUrl={logoUrl}
            />

            <div
                data-elementor-type="wp-page"
                data-elementor-id="5022"
                className="elementor elementor-5022"
                data-elementor-post-type="page"
            >
                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-0010e4b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="0010e4b"
                    data-element_type="section"
                >
                    <div className="elementor-container elementor-column-gap-default">
                        <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c2f71f2"
                            data-id="c2f71f2"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                    className="elementor-element elementor-element-9b4bb2b elementor-widget elementor-widget-spacer"
                                    data-id="9b4bb2b"
                                    data-element_type="widget"
                                    data-widget_type="spacer.default"
                                >
                                    <div className="elementor-widget-container">
                                        <div className="elementor-spacer">
                                            <div className="elementor-spacer-inner"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-7ac75bc elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="7ac75bc"
                    data-element_type="section"
                >
                    <div className="elementor-container elementor-column-gap-default">
                        <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-53fc04e"
                            data-id="53fc04e"
                            data-element_type="column"
                            data-settings='{"background_background":"classic"}'
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                    className="elementor-element elementor-element-da8d532 elementor-widget elementor-widget-image"
                                    data-id="da8d532"
                                    data-element_type="widget"
                                    data-widget_type="image.default"
                                >
                                    <div className="elementor-widget-container">
                                        <img
                                            decoding="async"
                                            width={150}
                                            height={150}
                                            src={logoUrl}
                                            className="attachment-thumbnail size-thumbnail wp-image-13596"
                                            alt={user.name}
                                        />
                                    </div>
                                </div>
                                <div
                                    className="elementor-element elementor-element-dfa0dda elementor-widget elementor-widget-text-editor"
                                    data-id="dfa0dda"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                >
                                    <div className="elementor-widget-container">
                                        {`${formatMessage({
                                            id: 'Membre depuis',
                                            defaultMessage: 'Membre depuis',
                                        })}: ${moment(user.registeredAt).format('DD/MM/YYYY')}`}
                                        <br />
                                        {!_.isEmpty(user.languages) &&
                                            `${formatMessage({
                                                id: 'Langue(s) parlée(s)',
                                                defaultMessage: 'Langue(s) parlée(s)',
                                            })}: ${user.languages.map((e) => e.name).join(', ')}`}
                                    </div>
                                </div>
                                {user.reviewScore > 0 && (
                                    <div
                                        className="elementor-element elementor-element-34a4fbf elementor-star-rating--align-center elementor--star-style-star_fontawesome elementor-widget elementor-widget-star-rating"
                                        data-id="34a4fbf"
                                        data-element_type="widget"
                                        data-widget_type="star-rating.default"
                                    >
                                        <div className="elementor-widget-container">
                                            <div className="elementor-star-rating__wrapper">
                                                <div className="elementor-star-rating__title">{`(${
                                                    user.reviewsNumber
                                                } ${formatMessage({ id: 'avis', defaultMessage: 'avis' })})`}</div>
                                                <div
                                                    className="elementor-star-rating"
                                                    title={`${user.reviewScore}/5`}
                                                    itemType="http://schema.org/Rating"
                                                    itemScope={true}
                                                    itemProp="reviewRating"
                                                >
                                                    <RatingSarts rating={user.reviewScore} />
                                                    <span
                                                        itemType="ratingValue"
                                                        className="elementor-screen-only"
                                                    >{`${user.reviewScore}/5`}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {products[0]?.user?.numberExchange > 0 && (
                                    <div
                                        className="elementor-element elementor-element-29870fb elementor-widget elementor-widget-heading"
                                        data-id="29870fb"
                                        data-element_type="widget"
                                        data-widget_type="heading.default"
                                    >
                                        <div className="elementor-widget-container">
                                            <h2 className="elementor-heading-title elementor-size-default">
                                                {formatMessage({
                                                    id: 'Nombre de swap réalisé(s)',
                                                    defaultMessage: 'Nombre de swap réalisé(s)',
                                                })}
                                                : {products[0].user.numberExchange}
                                            </h2>
                                        </div>
                                    </div>
                                )}
                                <div
                                    className="elementor-element elementor-element-c9a7d8d elementor-widget elementor-widget-spacer"
                                    data-id="c9a7d8d"
                                    data-element_type="widget"
                                    data-widget_type="spacer.default"
                                >
                                    <div className="elementor-widget-container">
                                        <div className="elementor-spacer">
                                            <div className="elementor-spacer-inner"></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="elementor-element elementor-element-543b6c8 elementor-align-center elementor-widget elementor-widget-button"
                                    data-id="543b6c8"
                                    data-element_type="widget"
                                    data-widget_type="button.default"
                                >
                                    <div className="elementor-widget-container">
                                        <div className="elementor-button-wrapper">
                                            <a
                                                className="elementor-button elementor-button-link elementor-size-sm"
                                                href="#"
                                                role="button"
                                                onClick={handleSendMessageClick}
                                            >
                                                <span className="elementor-button-content-wrapper">
                                                    <span className="elementor-button-text">
                                                        {formatMessage({
                                                            id: 'Envoyer un message',
                                                            defaultMessage: 'Envoyer un message',
                                                        })}
                                                    </span>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-847cb75"
                            data-id="847cb75"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                    className="elementor-element elementor-element-5e34489 elementor-widget elementor-widget-heading"
                                    data-id="5e34489"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                >
                                    <div className="elementor-widget-container">
                                        <h3 className="elementor-heading-title elementor-size-default">
                                            {user.pseudo || user.name}
                                        </h3>
                                    </div>
                                </div>
                                <div
                                    className="elementor-element elementor-element-d73afc3 elementor-widget elementor-widget-heading"
                                    data-id="d73afc3"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                >
                                    <div className="elementor-widget-container">
                                        <h4 className="elementor-heading-title elementor-size-default">
                                            {formatMessage({ id: 'A propos', defaultMessage: 'A propos' })}
                                        </h4>
                                    </div>
                                </div>
                                <div
                                    className="elementor-element elementor-element-fa77cce elementor-widget elementor-widget-text-editor"
                                    data-id="fa77cce"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                >
                                    <div className="elementor-widget-container">
                                        {user.description && (
                                            <GoogleTranslate text={user.description}>
                                                {({ text, TranslateButton, Loading }) => (
                                                    <>
                                                        {Loading ? (
                                                            <div style={{ marginBottom: 30 }}>
                                                                <Loading />
                                                            </div>
                                                        ) : (
                                                            <p>{text}</p>
                                                        )}
                                                        <div style={{ textAlign: 'center', marginBottom: 40 }}>
                                                            <TranslateButton />
                                                        </div>
                                                    </>
                                                )}
                                            </GoogleTranslate>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className="elementor-element elementor-element-6c7bddc elementor-widget elementor-widget-heading"
                                    data-id="6c7bddc"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                >
                                    <div className="elementor-widget-container">
                                        <h4 className="elementor-heading-title elementor-size-default">
                                            {formatMessage({
                                                id: 'Choix de destinations',
                                                defaultMessage: 'Choix de destinations',
                                            })}
                                        </h4>
                                    </div>
                                </div>
                                <div
                                    className="elementor-element elementor-element-87624ba elementor-widget elementor-widget-text-editor"
                                    data-id="87624ba"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                >
                                    <div className="elementor-widget-container">
                                        {user.destinations && (
                                            <GoogleTranslate text={user.destinations}>
                                                {({ text, TranslateButton, Loading }) => (
                                                    <>
                                                        {Loading ? (
                                                            <div style={{ marginBottom: 30 }}>
                                                                <Loading />
                                                            </div>
                                                        ) : (
                                                            <p>{text}</p>
                                                        )}
                                                        <div style={{ textAlign: 'center', marginBottom: 40 }}>
                                                            <TranslateButton />
                                                        </div>
                                                    </>
                                                )}
                                            </GoogleTranslate>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-fca7cf8 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="fca7cf8"
                    data-element_type="section"
                >
                    <div className="elementor-container elementor-column-gap-default">
                        <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-4a1f573"
                            data-id="4a1f573"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap"></div>
                        </div>
                        <div
                            className="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-6b19d3b"
                            data-id="6b19d3b"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                    className="elementor-element elementor-element-e4c199e elementor-widget elementor-widget-spacer"
                                    data-id="e4c199e"
                                    data-element_type="widget"
                                    data-widget_type="spacer.default"
                                >
                                    <div className="elementor-widget-container">
                                        <div className="elementor-spacer">
                                            <div className="elementor-spacer-inner"></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="elementor-element elementor-element-abb93da elementor-widget elementor-widget-heading"
                                    data-id="abb93da"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                >
                                    <div className="elementor-widget-container">
                                        <h4 className="elementor-heading-title elementor-size-default">
                                            {formatMessage({
                                                id: 'Véhicule(s) proposé(s)',
                                                defaultMessage: 'Véhicule(s) proposé(s)',
                                            })}
                                        </h4>
                                    </div>
                                </div>

                                {products?.map((product) => {
                                    const numberOfBedsSpecificity = _.head(
                                        _.filter(
                                            product.productSpecificities,
                                            (item) => item.uuid === NUMBER_OF_BEDS_UUID,
                                        ),
                                    )

                                    return (
                                        <Link to={productRoutes.details(product)} key={product.id}>
                                            <section
                                                className="elementor-section elementor-inner-section elementor-element elementor-element-184ab2c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                                data-id="184ab2c"
                                                data-element_type="section"
                                            >
                                                <div className="elementor-container elementor-column-gap-default">
                                                    <div
                                                        className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-90c42af"
                                                        data-id="90c42af"
                                                        data-element_type="column"
                                                    >
                                                        <div className="elementor-widget-wrap elementor-element-populated">
                                                            <div
                                                                className="elementor-element elementor-element-6a3bd04 elementor-widget elementor-widget-spacer"
                                                                data-id="6a3bd04"
                                                                data-element_type="widget"
                                                                data-widget_type="spacer.default"
                                                            >
                                                                <div className="elementor-widget-container">
                                                                    <div className="elementor-spacer">
                                                                        <div className="elementor-spacer-inner"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="elementor-element elementor-element-c084028 elementor-widget elementor-widget-image"
                                                                data-id="c084028"
                                                                data-element_type="widget"
                                                                data-widget_type="image.default"
                                                            >
                                                                <div className="elementor-widget-container">
                                                                    {!_.isEmpty(product.images) && (
                                                                        <img
                                                                            decoding="async"
                                                                            width={799}
                                                                            height={533}
                                                                            src={urlJoin(
                                                                                BASE_URL,
                                                                                product.images[0].name.original,
                                                                            )}
                                                                            className="attachment-medium size-medium wp-image-13677"
                                                                            alt={product.name}
                                                                            sizes="100vw"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-81eeec1"
                                                        data-id="81eeec1"
                                                        data-element_type="column"
                                                    >
                                                        <div className="elementor-widget-wrap elementor-element-populated">
                                                            <div
                                                                className="elementor-element elementor-element-8697d39 elementor-view-default elementor-widget elementor-widget-icon"
                                                                data-id="8697d39"
                                                                data-element_type="widget"
                                                                data-widget_type="icon.default"
                                                            >
                                                                <div className="elementor-widget-container">
                                                                    <div className="elementor-icon-wrapper">
                                                                        <div className="elementor-icon elementor-animation-shrink">
                                                                            <BookmarkOfProduct productId={product.id} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="elementor-element elementor-element-81fa3d6 elementor-widget elementor-widget-heading"
                                                                data-id="81fa3d6"
                                                                data-element_type="widget"
                                                                data-widget_type="heading.default"
                                                            >
                                                                <div className="elementor-widget-container">
                                                                    <h2 className="elementor-heading-title elementor-size-default">
                                                                        {product.name}
                                                                    </h2>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="elementor-element elementor-element-2183bcc elementor-widget elementor-widget-text-editor"
                                                                data-id="2183bcc"
                                                                data-element_type="widget"
                                                                data-widget_type="text-editor.default"
                                                            >
                                                                <div className="elementor-widget-container">
                                                                    <p>
                                                                        {product.address && (
                                                                            <>
                                                                                {product.address.country} |{' '}
                                                                                {product.address.city}
                                                                            </>
                                                                        )}
                                                                        <br />
                                                                        {product.category?.name}{' '}
                                                                        {numberOfBedsSpecificity &&
                                                                            ` | ${numberOfBedsSpecificity.name}: ${
                                                                                _.find(
                                                                                    numberOfBedsSpecificity.choices,
                                                                                    {
                                                                                        value:
                                                                                            numberOfBedsSpecificity.choice,
                                                                                    },
                                                                                )?.label
                                                                            }`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            {product.reviewScore > 0 && (
                                                                <div
                                                                    className="elementor-element elementor-element-a9185dc elementor--star-style-star_fontawesome elementor-widget elementor-widget-star-rating"
                                                                    data-id="a9185dc"
                                                                    data-element_type="widget"
                                                                    data-widget_type="star-rating.default"
                                                                >
                                                                    <div className="elementor-widget-container">
                                                                        <div className="elementor-star-rating__wrapper">
                                                                            <div className="elementor-star-rating__title">
                                                                                ({product.reviewsNumber}{' '}
                                                                                {formatMessage({
                                                                                    id: 'avis',
                                                                                    defaultMessage: 'avis',
                                                                                })}
                                                                                )
                                                                            </div>
                                                                            <div
                                                                                className="elementor-star-rating"
                                                                                title={`${product.reviewScore}/5`}
                                                                                itemType="http://schema.org/Rating"
                                                                                itemProp="reviewRating"
                                                                            >
                                                                                <RatingSarts
                                                                                    rating={product.reviewScore}
                                                                                />
                                                                                <span
                                                                                    itemProp="ratingValue"
                                                                                    className="elementor-screen-only"
                                                                                >
                                                                                    {product.reviewScore}/5
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div
                                                                className="elementor-element elementor-element-5c8b671 elementor-widget elementor-widget-heading"
                                                                data-id="5c8b671"
                                                                data-element_type="widget"
                                                                data-widget_type="heading.default"
                                                            >
                                                                <div className="elementor-widget-container">
                                                                    <h2 className="elementor-heading-title elementor-size-default">
                                                                        {product.price}{' '}
                                                                        {formatMessage({
                                                                            id: 'RP/jour',
                                                                            defaultMessage: 'RP/jour',
                                                                        })}
                                                                    </h2>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </Link>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-c013645 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="c013645"
                    data-element_type="section"
                >
                    <div className="elementor-container elementor-column-gap-default">
                        <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e079404"
                            data-id="e079404"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                    className="elementor-element elementor-element-f2f40da elementor-widget elementor-widget-spacer"
                                    data-id="f2f40da"
                                    data-element_type="widget"
                                    data-widget_type="spacer.default"
                                >
                                    <div className="elementor-widget-container">
                                        <div className="elementor-spacer">
                                            <div className="elementor-spacer-inner"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-aa29ef1 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="aa29ef1"
                    data-element_type="section"
                >
                    <div className="elementor-container elementor-column-gap-default">
                        <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-fa5e36e"
                            data-id="fa5e36e"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap"></div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}

UserDetails.getServerSideProps = async (context, store) => {
    await getInitialPropsOfUser(context, store)
    const { id } = context.route.params
    const params = { 'user.id': id, _embed: ['user'] }
    await getInitialPropsOfProducts(context, store, { params, useUrlParams: false, usePagination: false })

    return {}
}
